export default {
  id: 'pi_1Hem2JHEOCSwhqQoLGJZV2zl',
  object: 'payment_intent',
  amount: 1000,
  amount_capturable: 0,
  amount_received: 0,
  application: null,
  application_fee_amount: null,
  canceled_at: null,
  cancellation_reason: null,
  capture_method: 'manual',
  charges: {
    object: 'list',
    data: [],
    has_more: false,
    total_count: 0,
    url: '/v1/charges?payment_intent=pi_1Hem2JHEOCSwhqQoLGJZV2zl',
  },
  client_secret: 'pi_1Hem2JHEOCSwhqQoLGJZV2zl_secret_vWTbm3LQDLiTph6AhKP8OASQW',
  confirmation_method: 'automatic',
  created: 1603304867,
  currency: 'usd',
  customer: null,
  description: null,
  invoice: null,
  last_payment_error: null,
  livemode: false,
  metadata: {},
  next_action: null,
  on_behalf_of: null,
  payment_method: null,
  payment_method_options: {},
  payment_method_types: ['card_present'],
  receipt_email: null,
  review: null,
  setup_future_usage: null,
  shipping: null,
  source: null,
  statement_descriptor: null,
  statement_descriptor_suffix: null,
  status: 'requires_payment_method',
  transfer_data: null,
  transfer_group: null,
};
